module.exports = __webpack_public_path__ + "img/ico_registroRecurso.1723b709.png";